import { Field } from 'formik';
import React from 'react';
import FieldSelect from '../FieldSelect/FieldSelect';

// eslint-disable-next-line react/display-name
export default React.memo((props) => {
  return <Field name="agenda" component={FieldSelect} placeholder="Select Agenda" {...props} />;
});
